<form [formGroup]="form.formGroup">

  <div class="flex flex-wrap gap-4">

    <div class="flex flex-col flex-1 min-w-[200px] space-y-2">

      <div class="flex flex-col mb-2">
        <label>Reservoir</label>
        <p-select [options]="reservoirs" formControlName="reservoir" optionLabel="name" appendTo="body"
          [placeholder]="getReservoirPlaceholderText(form.formGroup.controls.reservoir.value)"></p-select>
      </div>

      <p-fieldset legend="Reservoir Fluid PVT Conditions">
        <div class="flex space-x-2">
          <input [disabled]="disableNodal" id="bottomHole" type="radio" binary="true" (click)="pvtConditionsChange('bottomHole')"
            [checked]="pvtCondition === 'bottomHole'">
          <label for="bottomHole">Flowing Bottom-Hole</label>
        </div>

        <div class="flex space-x-2">
          <input [disabled]="disableNodal" id="farField" type="radio" binary="true" (click)="pvtConditionsChange('farField')"
            [checked]="pvtCondition === 'farField'">
          <label for="farField">Far-field Reservoir</label>
        </div>

        <div class="flex  space-x-2">
          <input [disabled]="disableNodal" id="average" type="radio" binary="true" (click)="pvtConditionsChange('average')"
            [checked]="pvtCondition === 'average'">
          <label for="average">Average Reservoir Conditions</label>
        </div>
      </p-fieldset>

    </div>

    <div class="border-r border-gray"></div>

    <div class="flex flex-col flex-1 min-w-[200px] space-y-2">
 
      <div class="flex flex-col">
        <label>Choke</label>
        <p-select [options]="chokes" formControlName="choke" optionLabel="name" appendTo="body"
          [placeholder]="getChokePlaceholderText(form.formGroup.controls.choke.value)"></p-select>
      </div>

      @if (false && form.formGroup.controls.choke.value) {
        <div class="flex align-items-center">
          <p-toggleswitch formControlName="chokeFlowCheck" binary="true"></p-toggleswitch>
          <label class="ml-2">Check for Choked Flow</label>
        </div>
      }

      <div class="flex flex-col">
        <label>{{ pressureLabel }}</label>
        <app-validated-number-input
          class="flex-1 min-w-0"
          [id]="'upstreamPressure'"
          [control]="control('upstreamPressure')"
          [value]="control('upstreamPressure').value"
          [validation]="pressureValidation"
          [unit]="pressureUnit"
        ></app-validated-number-input>
      </div>

      <div class="flex flex-col">
        <label>{{ temperatureLabel }}</label>
        <app-validated-number-input
          class="flex-1 min-w-0"
          [id]="'upstreamTemperature'"
          [control]="control('upstreamTemperature')"
          [value]="control('upstreamTemperature').value"
          [validation]="temperatureValidation"
          [unit]="tempUnit"
        ></app-validated-number-input>
      </div>
    </div>
  </div>

  @if (showRestartOperation && !disableNodal) {
    <div class="pt-4">
    <p-fieldset>
      <ng-template pTemplate="header">
        <div class="flex items-center">
          <input
            type="checkbox"
            binary="true"
            formControlName="includeRestartOperation"
            id="restartOp"
          >
          <label class="pl-2" for="restartOp">Restart Operation</label>
        </div>
      </ng-template>

      <app-restart-operation
        [disableRestartOperation]="!form.formGroup.value.includeRestartOperation"
        [formControlName]="form.formControlNames.restartOperation"
      ></app-restart-operation>

    </p-fieldset>
    </div>
  }

  @if (!showRestartOperation && !disableNodal) {
    <div class="pt-4">
    <p-fieldset legend="Restart Operation">
      <label class="validation-error">Restart operations are assumed to follow after a Shut-in operation or UDT.</label>
      </p-fieldset>
    </div>
  }

</form>